/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用者情報
 */
export interface Sgkb986aResUserInfoDto {
    /**
     * 使用需要者区分
     */
    usingJuyoshaDiv?: string;
    /**
     * 使用お客さま漢字氏名
     */
    usingVisitKnjnm?: string;
    /**
     * 使用お客さまカナ氏名
     */
    usingVisitKananame?: string;
    /**
     * 使用お客さま電話番号コード１
     */
    usingVisitTeldivision1?: string;
    /**
     * 使用お客さま電話番号コード１名称
     */
    usevisitteldiv1Aname?: string;
    /**
     * 使用お客さま電話番号１
     */
    usingVisitTel1?: string;
    /**
     * 使用お客さま電話番号コード２
     */
    usingVisitTeldivision2?: string;
    /**
     * 使用お客さま電話番号コード２名称
     */
    usevisitteldiv2Aname?: string;
    /**
     * 使用お客さま電話番号２
     */
    usingVisitTel2?: string;
    /**
     * 使用お客さま電話番号コード３
     */
    usingVisitTeldivision3?: string;
    /**
     * 使用お客さま電話番号コード３名称
     */
    usevisitteldiv3Aname?: string;
    /**
     * 使用お客さま電話番号３
     */
    usingVisitTel3?: string;
}

